// 9fbef606107a605d69c0edbcd8029e5d
module.exports = {
  ENV_DEVELOPMENT: 'development',
  ENV_PRODUCTION: 'production',
  ENV_PREVIEW: 'PREVIEW',
};
